import React from 'react';
import { ScrollReveal } from '../ui/ScrollReveal';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="w-full py-20 md:py-32 px-5" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        {/* Two blocks */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3">
          {/* For you */}
          <ScrollReveal data-id="element-4">
            <div className="bg-surface border border-border rounded-2xl p-6 md:p-8 h-full" data-id="element-5">
              <h3 className="text-xl font-bold text-white mb-6" data-id="element-6">
                Esto es para ti si:
              </h3>
              <div className="space-y-4" data-id="element-7">
                <div className="flex gap-3 items-start" data-id="element-8">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-500/15 flex items-center justify-center mt-0.5" data-id="element-9">
                    <CheckIcon className="w-3.5 h-3.5 text-green-400" data-id="element-10" />
                  </div>
                  <p className="text-neutral-300" data-id="element-11">
                    quieres sobresalir en México en Meta Reels
                  </p>
                </div>
                <div className="flex gap-3 items-start" data-id="element-12">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-500/15 flex items-center justify-center mt-0.5" data-id="element-13">
                    <CheckIcon className="w-3.5 h-3.5 text-green-400" data-id="element-14" />
                  </div>
                  <p className="text-neutral-300" data-id="element-15">
                    te urge dejar de improvisar el inicio
                  </p>
                </div>
                <div className="flex gap-3 items-start" data-id="element-16">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-500/15 flex items-center justify-center mt-0.5" data-id="element-17">
                    <CheckIcon className="w-3.5 h-3.5 text-green-400" data-id="element-18" />
                  </div>
                  <p className="text-neutral-300" data-id="element-19">
                    quieres crecer rápido sin sentirte falso
                  </p>
                </div>
                <div className="flex gap-3 items-start" data-id="element-20">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-500/15 flex items-center justify-center mt-0.5" data-id="element-21">
                    <CheckIcon className="w-3.5 h-3.5 text-green-400" data-id="element-22" />
                  </div>
                  <p className="text-neutral-300" data-id="element-23">
                    quieres plantillas, no teoría
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>

          {/* Not for you */}
          <ScrollReveal delay={0.1} data-id="element-24">
            <div className="bg-surface/50 border border-border/60 rounded-2xl p-6 md:p-8 h-full" data-id="element-25">
              <h3 className="text-xl font-bold text-neutral-400 mb-6" data-id="element-26">
                No es para ti si:
              </h3>
              <div className="space-y-4" data-id="element-27">
                <div className="flex gap-3 items-start" data-id="element-28">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-500/10 flex items-center justify-center mt-0.5" data-id="element-29">
                    <XIcon className="w-3.5 h-3.5 text-red-400/70" data-id="element-30" />
                  </div>
                  <p className="text-neutral-500" data-id="element-31">
                    quieres "arte" sin optimizar retención
                  </p>
                </div>
                <div className="flex gap-3 items-start" data-id="element-32">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-500/10 flex items-center justify-center mt-0.5" data-id="element-33">
                    <XIcon className="w-3.5 h-3.5 text-red-400/70" data-id="element-34" />
                  </div>
                  <p className="text-neutral-500" data-id="element-35">no vas a practicar</p>
                </div>
                <div className="flex gap-3 items-start" data-id="element-36">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-500/10 flex items-center justify-center mt-0.5" data-id="element-37">
                    <XIcon className="w-3.5 h-3.5 text-red-400/70" data-id="element-38" />
                  </div>
                  <p className="text-neutral-500" data-id="element-39">buscas magia sin grabar</p>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>

        {/* Divider */}
        <div className="my-16 md:my-24 h-px bg-gradient-to-r from-transparent via-border to-transparent" data-id="element-40" />

        {/* Transformation */}
        <ScrollReveal data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight mb-8" data-id="element-42">
            Lo que cambia cuando tienes un{' '}
            <span className="font-serif-italic text-accent-light" data-id="element-43">arsenal</span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.1} data-id="element-44">
          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-neutral-300" data-id="element-45">
            <p data-id="element-46">
              Tu cerebro deja de pelearse con{' '}
              <span className="text-white" data-id="element-47">"¿qué digo al inicio?"</span>
            </p>
            <p data-id="element-48">Porque ahora empiezas con:</p>
            <div className="pl-6 border-l-2 border-accent/40 space-y-2" data-id="element-49">
              <p className="text-white font-semibold" data-id="element-50">→ tensión clara</p>
              <p className="text-white font-semibold" data-id="element-51">→ ruta elegida</p>
              <p className="text-white font-semibold" data-id="element-52">
                → remate que obliga a seguir
              </p>
            </div>
            <p data-id="element-53">
              Y cuando tu entrada mejora,{' '}
              <span className="text-accent font-bold" data-id="element-54">
                todo lo demás por fin tiene chance.
              </span>
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}